import Vue from 'vue';
import VueI18n from 'vue-i18n';
import wysiwyg from "vue-wysiwyg";

Vue.use(VueI18n);
Vue.use(wysiwyg, {});

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function getCurrentLocate () {
  // i18n.locale = 'ru';
  // eslint-disable-next-line no-undef
  if ($cookies.get('locale')) {
    // eslint-disable-next-line no-undef
    return $cookies.get('locale');
  }

  return 'en';
}

export default new VueI18n({
  locale: getCurrentLocate(), // 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
});

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
  // this === VueI18n instance, so the locale property also exists here
  if (this.locale !== 'ru') {
    // proceed to the default implementation
  }

  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return (choicesLength < 4) ? 2 : 3;
};
